var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74074 6.8667C1.54428 6.8667 1.35587 6.91687 1.21696 7.00617C1.07804 7.09548 1 7.2166 1 7.34289C1 7.46918 1.07804 7.5903 1.21696 7.67961C1.35587 7.76891 1.54428 7.81908 1.74074 7.81908V6.8667ZM21 6.8667H1.74074V7.81908H21V6.8667Z",
    fill: "#979AA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5119 1.72803L6.03967 7.18438M15.9603 1.72803L12.4881 7.18438M13.9762 13.6328C13.9762 13.0048 13.3194 12.5812 12.0059 11.733C10.6746 10.8739 10.0089 10.4443 9.5119 10.7608C9.01586 11.0752 9.01586 11.9274 9.01586 13.6328C9.01586 15.3381 9.01586 16.1903 9.5119 16.5058C10.0079 16.8213 10.6746 16.3917 12.0059 15.5326C13.3194 14.6844 13.9762 14.2608 13.9762 13.6328Z",
    stroke: "#979AA8",
    strokeWidth: 1.36364,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9206 11.1526C20.9206 15.8292 20.9206 18.1674 19.4672 19.6198C18.0159 21.0732 15.6766 21.0732 11 21.0732C6.32339 21.0732 3.9851 21.0732 2.53173 19.6198C1.07935 18.1684 1.07935 15.8292 1.07935 11.1526C1.07935 6.47598 1.07935 4.13769 2.53173 2.68431C3.98609 1.23193 6.32339 1.23193 11 1.23193C15.6766 1.23193 18.0149 1.23193 19.4672 2.68431C20.4335 3.65058 20.7569 5.00872 20.8661 7.18431",
    stroke: "#979AA8",
    strokeWidth: 1.36364,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/inspection.efb1b5769422138f7e6b3fc3efe848e3.svg";
export { ForwardRef as ReactComponent };